import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Bentornato" subtitle="Accedi per vivere la notte milanese">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email" type="email" value={email} onChange={setEmail} testid="login-email" />
        <Field label="Password" type="password" value={password} onChange={setPassword} testid="login-password" />
        <div className="text-right -mt-2">
          <Link to="/password-dimenticata" data-testid="login-forgot-link" className="text-xs text-wyd-muted hover:text-wyd-accent transition-colors duration-200">Password dimenticata?</Link>
        </div>
        {error && <p data-testid="login-error" className="text-sm text-wyd-accent">{error}</p>}
        <button data-testid="login-submit" disabled={loading}
          className="w-full py-3 rounded-full bg-wyd-accent text-wyd-bg font-semibold hover:glow-magenta transition-shadow duration-300 disabled:opacity-60">
          {loading ? "Accesso..." : "Accedi"}
        </button>
      </form>
      <p className="mt-6 text-sm text-wyd-muted text-center">
        Non hai un account? <Link to="/register" className="text-wyd-accent font-medium">Registrati</Link>
      </p>
    </AuthShell>
  );
}

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-24">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display font-black text-3xl block text-center mb-8">WYD<span className="text-wyd-accent">.</span></Link>
        <div className="glass rounded-2xl p-8">
          <h1 className="font-display font-bold text-2xl">{title}</h1>
          <p className="text-wyd-muted text-sm mt-1 mb-6">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

export function Field({ label, type = "text", value, onChange, testid }) {
  return (
    <div>
      <label className="overline text-wyd-muted block mb-1.5">{label}</label>
      <input
        data-testid={testid}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        className="w-full px-4 py-3 rounded-xl bg-wyd-bg border border-white/10 text-white focus:ring-2 focus:ring-wyd-accent focus:outline-none"
      />
    </div>
  );
}
